import React from 'react';
import {InfiniteScroll} from 'antd-mobile';
import {useTranslation} from 'react-i18next';
import {goTo} from '@/utils';
import DetailNavTitle from '@/components/business/detail-nav-title';
import {TeamReportListContent} from '@/common-pages/proxy/proxy.type';
import TeamReportPanel from './teams/team-report-panel';
import MyTeams from './teams/my-teams';
import TeamTableBody from './teams/team-table-body';
import AgentLevelCards from './components/agent-level-cards';
import {useAgentDetail} from './use-agent-detail';
import {homePage} from '@/config';
import {ProgressiveCircularLoading} from '@fe-progressive/package-progressive/progressive-loading';

const AgentDetail = () => {
  const {t} = useTranslation();
  const {
    searchValue,
    searching,
    showMinCharsWarning,
    tier,
    tableStartDate,
    tableEndDate,
    agentInfoExtra,
    list,
    loading,
    hasMore,
    tableHeaderScrollRef,
    tableBodyScrollRef,
    handleTableHeaderScroll,
    handleTableBodyScroll,
    handleSearch,
    handleAutoSearch,
    handleSearchChange,
    handleDateRangeChange,
    handleTierChange,
    handleSortChange,
    loadMore,
    bodyCell,
    renderModal,
  } = useAgentDetail();

  return (
    <div className="flex flex-col w-[23.4375rem] h-full fixed top-0 left-1/2 -translate-x-1/2 bg-bg">
      <DetailNavTitle
        onBack={() => {
          goTo(homePage, {
            screen: 'EarnMoney',
            params: {
              tabKey: 'agent',
            },
          });
        }}
        title={t('agent.subordinateData')}
        hideServer={true}
        hideAmount={true}
      />
      <div className="flex flex-col flex-1 bg-bg overflow-y-auto gap-3 pt-3">
        <AgentLevelCards agentInfoExtra={agentInfoExtra} />
        <TeamReportPanel />
        <div className="flex flex-col">
          <MyTeams
            tier={tier}
            searching={searching}
            onChangeSort={handleSortChange}
            dateRange={
              tableStartDate && tableEndDate
                ? [tableStartDate, tableEndDate]
                : undefined
            }
            onChangeDateRange={handleDateRangeChange}
            onChangeTier={handleTierChange}
            ref={tableHeaderScrollRef}
            onScroll={handleTableHeaderScroll}
            isEmpty={list.length === 0}
            searchValue={searchValue}
            onSearchChange={handleSearchChange}
            onSearch={handleSearch}
            onAutoSearch={handleAutoSearch}
            isSearching={loading}
            resultCount={list.length}
            showMinCharsWarning={showMinCharsWarning}
          />
          <TeamTableBody
            ref={tableBodyScrollRef}
            loading={loading}
            onScroll={handleTableBodyScroll}
            data={list}
            rowKey={item => (item as TeamReportListContent).userId.toString()}
            bodyCell={bodyCell}
            showSearchEmpty={
              searching && !!searchValue && searchValue.length > 0
            }
          />
        </div>

        <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
          {list.length ? (
            hasMore ? (
              <ProgressiveCircularLoading size={20} aria-label="Loading" />
            ) : (
              'No More Data'
            )
          ) : (
            ''
          )}
        </InfiniteScroll>
        {renderModal}
      </div>
    </div>
  );
};

export default AgentDetail;
